module.exports = __webpack_public_path__ + "u15.no2.b8e8f6c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/u15.no2.jpg
// module id = 89JA
// module chunks = 0